var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuw-center",attrs:{"id":"more-results"}},[_c('i',{staticClass:"fal fa-arrow-down"})])}]

export { render, staticRenderFns }